<template>
  <nav v-if="$auth.check()" class="navbar navbar-default navbar-fixed-top be-top-header">
    <div class="container-fluid">
      <div class="page-title"><span>АИС "Курортный сбор"<sup class="small"
                                                             style="color:darkgrey">(v.1.3)</sup></span></div>
      <div class="be-right-navbar">
        <ul class="nav navbar-nav navbar-right be-user-nav">
          <li class="dropdown"><a href="#" data-toggle="dropdown" role="button" aria-expanded="false"
                                  class="dropdown-toggle"><img src="static/assets/img/avatar.png" alt="Avatar"><span
            class="user-name"></span>Профиль</a>
            <ul role="menu" class="dropdown-menu">
              <li>
                <div class="user-info">
                  <div class="user-name">{{ $auth.user().email }}</div>
                  <div v-if="$auth.user().is_superuser" class="user-position online">Администратор</div>
                  <div v-if="$auth.user().is_guest" class="user-position online">Гость</div>
                  <div v-if="!$auth.user().is_guest && !$auth.user().is_superuser" class="user-position online">
                    Пользователь
                  </div>
                </div>
              </li>
              <li v-if="$auth.user().is_superuser"><a href="/admin/"><span class="icon mdi mdi-settings"></span>Администрирование</a>
              </li>
              <router-link tag="li":to="{name: 'userProfile', params: {id: $auth.user().user_id}}">
                <a href=""><span class="icon mdi mdi-settings"></span>Профиль пользователя</a>
              </router-link>
              <li><a href="#" @click="logout"><span class="icon mdi mdi-power"></span> Выйти</a></li>
            </ul>
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-right be-icons-nav">
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>

  export default {
    methods: {
      logout () {
        this.$auth.logout()
        this.$router.go('login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NavHeader.vue